import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-content flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200/70 text-foreground-500">
        <i className="ri-file-unknow-line text-3xl" />
      </span>
      <p className="mt-6 text-xs tracking-[0.32em] text-accent-500">404 · NOT FOUND</p>
      <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
        这一页没有被归档
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的档案可能已经移动或不存在。回到档案库，从完整的时间线开始查起。
      </p>
      <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
        <Link
          to="/"
          className="w-full whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors duration-200 hover:bg-primary-500 sm:w-auto cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/archive"
          className="w-full whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-800 transition-colors duration-200 hover:border-accent-500 hover:text-accent-400 sm:w-auto cursor-pointer"
        >
          浏览复盘档案库
        </Link>
      </div>
    </div>
  );
}